import NotFoundView from '../views/erros/403ErrorView.vue'
import ErrorView from '../views/erros/404ErrorView.vue'
import HomeView from '../views/home/HomeView.vue'

const homeRoutes = [

    { name:'HomeView',  path: '/',  component: HomeView},
    { name:'403',  path: '/403',  component: NotFoundView},
    { name:'404',  path: '/404',  component: ErrorView}

    //No Plugin BHPRO
];

export default homeRoutes